import { oc } from '@orpc/contract'
import { z } from 'zod'

export const versionContract = oc.input(z.object({}).optional()).output(
  z.object({
    name: z.string(),
    version: z.string(),
  })
)
